import './sessions_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SurveySessionsView extends Monitoring.Views.SocialContents.SessionsView

  _newTabDashboardView: (uuid) ->
    options = $.extend {}, @_newTabDashboardViewOptions(uuid),
      defaultCharts: [] # Charts need to be initialized in DashboardSurveyView because they need facets
    new Monitoring.Views.SocialContents.SurveysDashboardView options

  _existingSessionDashboardView: (session, options) ->
    new Monitoring.Views.SocialContents.SurveysDashboardView(
      $.extend {}, options, @_commonDashboardViewOptions(), session: session
    )

  _deleteAllSessionRecords: ->
    $.ajax
      type: 'POST'
      url: '/surveys/sessions/delete_all'
      data: {}
      success: @_triggerSessionListChange

  _updateSessions: =>
    $.ajax
      type: 'GET'
      url: '/surveys/sessions/current_sessions'
      contentType: 'application/json; charset=utf-8'
      success: @_updateSessionLists

  _getCurrentSessionNameAndContinue: =>
    $.ajax
      type: 'GET'
      url: '/surveys/sessions/current_session_of_user'
      contentType: 'application/json; charset=utf-8'
      dataType: 'json'
      success: @_triggerCurrentSessionObtained


  _updateCurrentSession: (sessionName) ->
    $.ajax
      type: 'PUT'
      url: '/surveys/sessions/current_session_of_user'
      data:
        current_session: sessionName
